(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('manifest-book-gallery')) {
    customElements.define('manifest-book-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const cover = this.querySelector('[data-gallery-image]');
        const zoom = this.querySelector('.c-image-overlay__image');
        const buttons = this.querySelectorAll('[data-gallery-choice]');
        buttons.forEach(button => button.addEventListener('click', () => {
          cover.src = button.dataset.src;
          cover.srcset = button.dataset.srcset;
          cover.alt = button.dataset.alt;
          cover.height = Number(button.dataset.height);
          if (zoom) {
            zoom.src = button.dataset.zoomSrc;
            zoom.srcset = button.dataset.zoomSrcset;
            zoom.alt = button.dataset.alt;
            zoom.height = Number(button.dataset.zoomHeight);
          }
          buttons.forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
